var EHDI = (function(ehdi){
    ehdi.DBoneFactory =  (function(){
        var publicVar = Object.create(null);
        var enableClock = true;
        var armatures = [];
        var skelData = Object.create(null);

        var loop = function(dt){
            dragonBones.WorldClock.clock.advanceTime(dt * publicVar.dtMultiplier);
        }

        publicVar.dtMultiplier = 0.001;

        Object.defineProperty(publicVar, "enableClock", {
            set: function(val){
                enableClock = val;
                if(enableClock && !EHDI.GAME.updateManager.hasFrameListener(loop)){
                    EHDI.GAME.updateManager.addFrameListener(loop);
                }
                if(!enableClock && EHDI.GAME.updateManager.hasFrameListener(loop)){
                    EHDI.GAME.updateManager.removeFrameListener(loop);
                }
            },
            get: function(){
                return enableClock;
            }
        });

        publicVar.createArmature = function(name){
            var newArmature = publicVar.PixiFactory.buildArmature(name);
            dragonBones.WorldClock.clock.add(newArmature);
            armatures.push(newArmature);
            return newArmature;
        }

        publicVar.destroyArmature = function(armature){
            var index = armatures.indexOf(armature);
            if(index > -1){
                var arm = armatures.splice(index, 1)[0];
                dragonBones.WorldClock.clock.remove(arm);
                arm.dispose();
            }
        }

        publicVar.destroyAllArmature = function(){
            while(armatures.length > 0){
                var arm = armatures.pop();
                dragonBones.WorldClock.clock.remove(arm);
                arm.dispose();
            }
        }

        /**
        * @param (STRING) imgID texture file(png)
        * @param (STRING) dataID string file(json)
        * @param (STRING) SkelID string file(json)
        */
        publicVar.start = function(imgID, dataID, skelID){
            publicVar.PixiFactory = new dragonBones.PixiFactory();
            publicVar.addToFactory(imgID, dataID, skelID);
            publicVar.enableClock = true;
        }

        publicVar.addToFactory = function(imgID, dataID, skelID){
            var textureImg = EHDI.Assets.images[imgID].baseTexture.source;
            var textureData = EHDI.Assets.fetch(dataID);
            var skel = EHDI.Assets.fetch(skelID);
            
            publicVar.PixiFactory.addTextureAtlas(new dragonBones.TextureAtlas(textureImg, textureData));
            publicVar.PixiFactory.addDragonBonesData(dragonBones.DataParser.parseDragonBonesData(skel));
        }

        return publicVar;
        }());

    return ehdi;
}(EHDI || Object.create(null)));
